import { FC, memo } from 'react';
import { useLocation } from 'react-router-dom';
import { useDeliveriesByCourseQuery } from 'src/hooks/useDeliveriesByCourse.query';

import DeliveryByCourseReportPresenter from './DeliveryByCourseReportPresenter';
import { useIssueDateTime } from './reports/useIssueDateTime';

/**
 * 納品先別コースリスト のページ。
 * `/deliveries-by-course?start_on=YYYY-MM-DD&end_on=YYYY-MM-DD&shipper_names[]=...` で表示される。
 */
const DeliveryByCourseReport: FC = memo(() => {
  const query = new URLSearchParams(useLocation().search);
  const startOn = query.get('start_on') ?? '';
  const endOn = query.get('end_on') ?? '';
  const shipperNames = query.getAll('shipper_names[]');

  const { data, isLoading, isError } = useDeliveriesByCourseQuery({
    startOn,
    endOn,
    shipperNames,
  });
  const { issueDate, issueTime } = useIssueDateTime();

  return (
    <DeliveryByCourseReportPresenter
      data={data}
      isLoading={isLoading}
      isError={isError}
      issueDate={issueDate}
      issueTime={issueTime}
    />
  );
});

export default DeliveryByCourseReport;
